<template>
  <div v-if="visible" class="tcd-mask" @click.self.prevent>
    <div class="tcd-dialog" @click.stop>
      <span class="tcd-close" @click="$emit('close')"></span>
      <p class="tcd-title">{{ $t(titleKey) }}</p>
      <p v-if="descKey" class="tcd-desc">{{ $t(descKey) }}</p>
      <div class="tcd-amount">
        <img src="../../assets/withdrawal_v2/$.png" alt="" />
        <span>{{ amount }}</span>
      </div>
      <!-- <div v-if="tips.length" class="tcd-tips">
        <p class="tcd-tips-title">{{ $t(tipsTitleKey) }}</p>
        <ul>
          <li v-for="(tip, index) in tips" :key="index">
            {{ $t(tip.key, tip.params || {}) }}
          </li>
        </ul>
      </div> -->
      <div class="tcd-actions">
        <button type="button" class="tcd-ok" @click="$emit('confirm')">
          {{ $t(confirmKey) }}
        </button>
        <button type="button" class="tcd-cancel" @click="$emit('close')">
          {{ $t(cancelKey) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 转移类确认弹窗（2026-06-08）
 * Reseller / 公会长等页面复用；文案与金额由父组件传参
 */
export default {
  name: "transfer-confirm-dialog",
  props: {
    visible: { type: Boolean, default: false },
    amount: { type: String, default: "" },
    descKey: { type: String, default: "" },
    titleKey: { type: String, default: "guild_confirm_transfer" },
    tipsTitleKey: { type: String, default: "guild_bind_notice_title" },
    confirmKey: { type: String, default: "guild_appeal_to_platform" },
    cancelKey: { type: String, default: "guild_withdraw_note_4" },
    tips: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.tcd-mask {
  position: fixed;
  inset: 0;
  z-index: 400;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 48px;
  box-sizing: border-box;
}

.tcd-dialog {
  position: relative;
  width: 100%;
  max-width: 590px;
  max-height: 85vh;
  overflow-y: auto;
  background: #fff;
  border-radius: 24px;
  padding: 60px 32px 32px;
  box-sizing: border-box;
  font-family: "Mada", sans-serif;
}

.tcd-close {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 28px;
  height: 28px;
  cursor: pointer;
}

.tcd-close::before,
.tcd-close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 2px;
  background: #121212;
}

.tcd-close::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.tcd-close::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.tcd-title {
  margin: 0 0 16px;
  font-size: 28px;
  font-weight: 500;
  text-align: center;
  color: #1f1315;
}

.tcd-desc {
  margin: 32px 0 24px;
  font-size: 24px;
  line-height: 36px;
  font-weight: 400;
  text-align: center;
  color: #504c54;
}

.tcd-amount {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
}

.tcd-amount img {
  width: 52px;
  height: 52px;
}

.tcd-amount span {
  font-size: 40px;
  font-weight: 700;
  color: #262427;
}

.tcd-tips {
  margin-bottom: 32px;
  padding: 20px 24px;
  border-radius: 16px;
  background: linear-gradient(
    360deg,
    rgba(255, 147, 147, 0) 0%,
    rgba(255, 147, 147, 0.25) 100%
  );
  font-size: 22px;
  line-height: 34px;
  color: #262427;
}

.tcd-tips-title {
  margin: 0 0 12px;
  font-size: 24px;
  font-weight: 500;
  color: #ff4365;
}

.tcd-tips-title::before {
  display: inline-block;
  content: "";
  width: 32px;
  height: 32px;
  background: url("../../assets/withdrawal_v2/elert.png") no-repeat;
  background-size: 100% 100%;
  vertical-align: top;
  margin-right: 8px;
}

.tcd-tips ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.tcd-tips li {
  margin-bottom: 8px;
}

.tcd-tips li:last-child {
  margin-bottom: 0;
}

.tcd-actions {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 412px;
  margin: 0 auto;
}

.tcd-ok,
.tcd-cancel {
  width: 100%;
  height: 80px;
  border-radius: 40px;
  font-size: 24px;
  font-weight: 500;
  border: none;
}

.tcd-ok {
  background: #8131e7;
  color: #fff;
}

.tcd-cancel {
  background: #fff;
  color: #262427;
  border: 1px solid #dbdbdb;
}

html[lang="ar"] .tcd-dialog {
  direction: rtl;
}

html[lang="ar"] .tcd-close {
  right: auto;
  left: 24px;
}

html[lang="ar"] .tcd-tips-title::before {
  margin-right: 0;
  margin-left: 8px;
}
</style>
